import { render, staticRenderFns } from "./personal-training.vue?vue&type=template&id=388978ca&"
import script from "./personal-training.vue?vue&type=script&lang=js&"
export * from "./personal-training.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports